<template>
  <div>
    <a-tabs :active-key="activeKey" @change="changeTab">
      <a-tab-pane
        v-for="item in showHasPermissionTabs"
        :key="item.routeName"
        :tab="item.tabName"
      >
        <router-view v-if="activeKey===item.routeName" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import { hasPermission } from '@/utils/permission'
import { findEsimSupplierName } from '@/api/esim_supplier'

export default {
  name: 'ShowEsimSupplierTab',
  data() {
    return {
      activeKey: '',
      allTabs: [
        { routeName: 'esim_supplier_info', tabName: '基本信息', menu: 'esim_suppliers/show' },
        { routeName: 'esim_supplier_esims', tabName: '已划拨eSIM列表', menu: 'esim_supplier_esims' }
      ],
      showHasPermissionTabs: []
    }
  },
  computed: {
    esimSupplierId() {
      return parseInt(this.$route.params.id)
    }
  },
  watch: {
    esimSupplierId() {
      this.setBreadcrumb()
    }
  },
  created() {
    this.activeKey = this.$route.name
    this.fetchShowHasPermissionTabs()
    this.setBreadcrumb()
  },
  methods: {
    setBreadcrumb() {
      findEsimSupplierName(this.esimSupplierId).then((res) => {
        if (res.code === 0) {
          this.$store.dispatch('SetDynamicBreadCrumbsPlaceholder', { ':esim_supplier_name': res.data.name })
        }
      })
    },

    isShowMenu(menu) {
      return hasPermission(menu)
    },

    fetchShowHasPermissionTabs() {
      let isIncludeActiveKey = false

      this.allTabs.forEach((value) => {
        if (this.isShowMenu(value.menu)) {
          this.showHasPermissionTabs.push(value)
          if (value.routeName === this.activeKey) {
            isIncludeActiveKey = true
          }
        }
      })

      if (!isIncludeActiveKey && this.showHasPermissionTabs.length > 0) {
        this.activeKey = this.showHasPermissionTabs[0].routeName
      }
    },

    changeTab(activeKey) {
      this.activeKey = activeKey
      this.$router.push({ name: activeKey })
    }
  }
}
</script>
